import { useAppUser } from 'components/_hooks'
import React from 'react'
import { Redirect, Route, RouteComponentProps } from 'react-router-dom'
import { UserRole } from 'store/types/app-types'
import { isEqualRoles } from 'store/types/user-types'

export interface CommonRoleRouteProps {
  exact?: boolean
  path: string
  component?: React.ComponentType<RouteComponentProps<unknown>> | React.ComponentType<unknown>

}

interface RoleRouteProps extends CommonRoleRouteProps {
  defaultPath: string
  roles?: UserRole[]
}

export const RoleRoute = ({ path, exact, component, roles, defaultPath }: RoleRouteProps) => {
  const appUser = useAppUser()

  const renderComponent = (props: RouteComponentProps) => {
    if (roles) {
      if (!appUser) {
        return (
          <Redirect to={defaultPath} />
        )
      }
  
      const isInRole = roles.some(role => isEqualRoles(appUser.Role, role))
      if (!isInRole) {
        return (
          <Redirect to={defaultPath} />
        )
      }
    }

    const Component = component
    return (
      <Component {...props} />
    )
  }

  return (
    <Route
      exact={exact}
      path={path}
      component={renderComponent}
    />
  )
}
